import { UserInfoType } from "@/types/user_info.types";
import { UserJoinType } from "@/types/user_join.types";
import { atom, selector } from "recoil";
import { v1 } from "uuid";

export const userInfoState = atom<UserInfoType | null>({
  key: `userInfoState/${v1()}`,
  default: null,
});

export const userInfoSelector = selector<UserInfoType | null>({
  key: `userInfoSelector/${v1()}`,
  get: ({ get }) => {
    return get(userInfoState);
  },
  set: ({ set }, userInfo) => {
    set(userInfoState, userInfo);
  },
});

export const joinFormState = atom<UserJoinType | null>({
  key: `joinFormState/${v1()}`,
  default: {
    term_agreements: false,
    user_id: "",
    password: "",
  },
});

export const joinFormSelector = selector<UserJoinType | null>({
  key: `joinFormSelector/${v1()}`,
  get: ({ get }) => {
    return get(joinFormState);
  },
  set: ({ set }, newInfo) => {
    set(joinFormState, newInfo);
  },
});
